const ACTION_ROWS = [
  ["V2_CARBON_PROJECT_CREATION", "typedCreationPrepare", "interactive", "carbon project creation form", true],
  ["V2_PROJECT_APPROVAL", "projectReadiness", "interactive", "admin project approval", true],
  ["V2_PROJECT_FUNDING_SUSPENSION", "projectReadiness", "interactive", "admin project funding controls", true],
  ["V2_PROJECT_FUNDING_REACTIVATION", "projectReadiness", "interactive", "admin project funding controls", true],
  ["V2_CARBON_INVESTMENT", "projectReadiness", "interactive", "investment sidebar", true],
  ["V2_CARBON_RECEIPT_TRANSFER", "projectReadiness", "validationOnly", "typed API and readiness validation", false],
  ["V2_CARBON_CREDIT_CLAIM", "projectReadiness", "interactive", "investment claim sidebar", false],
  ["V2_CARBON_REFUND_CLAIM", "projectReadiness", "interactive", "investment refund sidebar", false],
  ["V2_CARBON_DEVELOPER_WITHDRAWAL", "projectReadiness", "interactive", "developer project card and investment detail", true],
  ["V2_CARBON_TREASURY_FEE_WITHDRAWAL", "projectReadiness", "validationOnly", "typed API and readiness validation", true],
  ["V2_STABLECOIN_APPROVAL", "projectReadiness", "orchestrated", "investment allowance step", true],
  ["V2_CERTIFIER_ASSIGNMENT_ACCEPT", "projectReadiness", "interactive", "auditor dashboard", true],
  ["V2_PROJECT_FAILURE", "projectReadiness", "interactive", "Carbon operations console", true],
  ["V2_STAGE_PRINCIPAL_RELEASE", "projectReadiness", "interactive", "auditor dashboard", true],
  ["V2_STAGE_REFUND_FINALIZE", "projectReadiness", "interactive", "Carbon operations console", true],
  ["V2_COMPENSATION_PLAN_CONFIGURE", "projectReadiness", "interactive", "auditor lifecycle workflow", true],
  ["V2_COMPENSATION_ACCRUAL", "projectReadiness", "interactive", "auditor lifecycle workflow", true],
  ["V2_COMPENSATION_WITHDRAWAL", "projectReadiness", "interactive", "benefit claim button", true],
  ["V2_COMPENSATION_STOP", "projectReadiness", "interactive", "auditor lifecycle workflow", true],
  ["V2_CREDIT_BINDING_APPROVAL", "projectReadiness", "interactive", "Carbon operations console", true],
  ["V2_CREDIT_YEAR_FINALIZE", "projectReadiness", "interactive", "Carbon operations console", true],
  ["V2_VERIFIED_CREDIT_SERIES_CREATE", "projectReadiness", "interactive", "Carbon operations console", true],
  ["V2_VERIFIED_CREDIT_ISSUE", "projectReadiness", "interactive", "Carbon operations console", true],
  ["V2_MARKETPLACE_RECEIPT_APPROVAL", "projectReadiness", "orchestrated", "marketplace listing approval step", true],
  ["V2_MARKETPLACE_STABLECOIN_APPROVAL", "projectReadiness", "orchestrated", "marketplace purchase allowance step", true],
  ["V2_MARKETPLACE_LISTING_CREATE", "projectReadiness", "interactive", "marketplace sell form", true],
  ["V2_MARKETPLACE_LISTING_BUY", "projectReadiness", "interactive", "marketplace purchase sidebar", true],
  ["V2_MARKETPLACE_LISTING_CANCEL", "projectReadiness", "validationOnly", "typed API and readiness validation", true],
  ["V2_TREASURY_RECEIPT_RELAY", "projectReadiness", "orchestrated", "admin receipt relay console", false],
];

export const CARBON_V2_ACTION_COVERAGE = Object.freeze(
  Object.fromEntries(
    ACTION_ROWS.map(
      ([operationType, gate, disposition, consumer, directWalletCapable]) => [
        operationType,
        Object.freeze({
          operationType,
          gate,
          disposition,
          consumer,
          directWalletCapable,
        }),
      ]
    )
  )
);

export const CARBON_V2_OPERATION_TYPES = Object.freeze(
  Object.keys(CARBON_V2_ACTION_COVERAGE)
);

export const CARBON_V2_READINESS_OPERATION_TYPES = Object.freeze(
  CARBON_V2_OPERATION_TYPES.filter(
    (operationType) =>
      CARBON_V2_ACTION_COVERAGE[operationType].gate === "projectReadiness"
  )
);

export const DIRECT_WALLET_CAPABLE_OPERATION_TYPES = Object.freeze(
  CARBON_V2_OPERATION_TYPES.filter(
    (operationType) =>
      CARBON_V2_ACTION_COVERAGE[operationType].directWalletCapable
  )
);
